export function AdminTable({ children, footer, className = "" }) {
  return (
    <div className={`overflow-x-auto bg-white ${className}`}>
      <table className="min-w-full divide-y divide-gray-100">{children}</table>
      {footer}
    </div>
  );
}

export function AdminTableHead({ children }) {
  return (
    <thead className="bg-slate-50/80">
      <tr>{children}</tr>
    </thead>
  );
}

export function AdminTableTh({ children, align = "left", className = "" }) {
  const alignClass = align === "right" ? "text-right" : "text-left";

  return (
    <th
      scope="col"
      className={`px-4 py-2 text-[11px] font-semibold uppercase tracking-wide text-gray-500 sm:px-5 ${alignClass} ${className}`}
    >
      {children}
    </th>
  );
}

export function AdminTableBody({ children }) {
  return <tbody className="divide-y divide-gray-100 bg-white">{children}</tbody>;
}

export function AdminTableRow({ children, className = "" }) {
  return (
    <tr className={`transition-colors hover:bg-slate-50/60 ${className}`}>{children}</tr>
  );
}

export function AdminTableCell({ children, align = "left", className = "", nowrap = true }) {
  const alignClass = align === "right" ? "text-right" : "";
  const nowrapClass = nowrap ? "whitespace-nowrap" : "";

  return (
    <td
      className={`px-4 py-2 text-sm leading-snug text-gray-900 sm:px-5 ${nowrapClass} ${alignClass} ${className}`}
    >
      {children}
    </td>
  );
}

export function AdminTableToolbar({ children, className = "" }) {
  return (
    <div className={`mb-4 ${className}`}>
      <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
        {children}
      </div>
    </div>
  );
}

export function AdminTableFooter({ children }) {
  return (
    <div className="border-t border-gray-100 bg-slate-50/30 px-4 py-3 sm:px-5">
      {children}
    </div>
  );
}
